export { networkAdapter } from '@/adapters/network/networkAdapter';
export type { NetworkAdapter, NetworkState } from '@/adapters/network/types';
